import { z } from 'zod'
import { RoadmapActivityCategory, RoadmapActivityStatus } from './types'

/** Effort in points: a non-negative whole number, typed into a text field. */
const pointsField = z
	.string()
	.trim()
	.refine((value) => {
		const points = Number(value)
		return value !== '' && Number.isInteger(points) && points >= 0
	}, 'roadmaps:error_points_invalid')

/**
 * Error messages are i18n keys, resolved at render time: the schema has no
 * access to `t`, and the form is the only place the strings are shown.
 */
export const ActivityFormSchema = z
	.object({
		title: z.string().trim().min(1, 'roadmaps:error_title_required'),
		category: RoadmapActivityCategory,
		status: RoadmapActivityStatus,
		dateFrom: z.string().min(1, 'roadmaps:error_date_from_required'),
		dateTo: z.string().min(1, 'roadmaps:error_date_to_required'),
		// Kept as the string the input actually holds, rather than coerced:
		// z.coerce.number() types its input as unknown in Zod 4, which would
		// leak into the form values. Converted to a number at submit.
		backendPoints: pointsField,
		frontendPoints: pointsField,
		lead: z.string().trim().min(1, 'roadmaps:error_lead_required')
	})
	// Both ends are inclusive, so an equal pair is a valid one-day activity.
	// The backend enforces this too; checking here keeps a round trip out of
	// the common mistake.
	.refine((values) => values.dateFrom <= values.dateTo, {
		message: 'roadmaps:error_date_range',
		path: ['dateTo']
	})

export type ActivityFormValues = z.input<typeof ActivityFormSchema>
export type ActivityFormOutput = z.output<typeof ActivityFormSchema>
